<!--SolarTool--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<template>
    <v-container grid-list-md text-center v-if="$store.state.pageSolarToolActive">
        <v-dialog v-model="closeSolarTool" width="1000">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    SolarTool
                </v-card-title>
                <v-card-text>
                    <v-flex xs12 sm12>
                    </v-flex>
                    <v-card-text align="left">
                        <h3>Voulez-vous quitter SolarTool ? Toutes les données seront effacées.</h3>
                    </v-card-text>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeSolarTool = false">
                        Annuler
                    </v-btn>
                    <v-btn color="primary" text @click="mainPageActive()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout wrap>
            <v-flex	xs12>
                <v-card color="grey lighten-5" height="auto">
                    <v-card-title>
                        <v-flex xs10 sm10 class="text-left">
                            <h3>SolarTool</h3>
                        </v-flex>
                        <v-flex 
                            v-if="!$store.state.SolarToolCustomerNumberIsValid"
                            xs10 sm10 class="text-left">
                            <small> Recherche de numéro de client</small>
                        </v-flex>
                        <v-flex xs1 sm1>
                            <v-btn text @click="closeSolarTool=true" class="text-right">X</v-btn>
                        </v-flex>
                    </v-card-title>
                    <v-card-text v-if="!$store.state.pageSolarToolResultsActive">
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="3"
                                    sm="3"
                                    md="3"
                                >
                                    <v-autocomplete
                                        label="Numéro de client :"
                                        v-model="$store.state.SolarToolCustomerNumber"
                                        :items="$store.state.SolarToolCustomersList"
                                        @change="customerNumberCheck()"
                                        variant="outlined"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col
                                    v-if="$store.state.SolarToolCustomerNumberIsValid"
                                    cols="5"
                                    sm="5"
                                    md="5"
                                >
                                    <v-chip color="primary" variant="flat">
                                        {{$store.state.SolarToolFoundCustomers[0].Name_1}}
                                    </v-chip>
                                </v-col>
                                <v-col
                                    cols="2"
                                    sm="2"
                                    md="2"
                                >
                                    <v-btn @click="openSearchCustomerTile()">
                                        Rechercher n° client
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-dialog v-model="$store.state.SolarToolSearchCustomerNumber" width="1000">
                            <v-card @keydown.enter="searchCustomer()">
                                <v-card-title class="headline grey lighten-2" primary-title>
                                    Recherche client
                                </v-card-title>
                                <v-card-text>
                                    <FormulaireRechercheClient/>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn 
                                        color="primary" 
                                        text 
                                        @click="searchCustomer()"
                                    >
                                        Rechercher
                                    </v-btn>
                                    <v-btn 
                                        color="primary" 
                                        text 
                                        @click="closeCustomerSearchForm()"
                                    >
                                        Annuler
                                    </v-btn>
                                </v-card-actions>
                                <v-progress-linear
                                    v-if="$store.state.SolarToolSearchCustomerNumberInProgress" 
                                    :indeterminate="true" 
                                    class="progress" 
                                    rounded
                                ></v-progress-linear>
                            </v-card>
                        </v-dialog>
                        <v-data-table
                            v-if="$store.state.SolarToolFoundCustomersDataTableVisible"
                            :headers="$store.state.SolarToolFoundCustomersHeaders"
                            :items="$store.state.SolarToolFoundCustomers"
                            :items-per-page="10"
                            :single-select="true"
                            :search="$store.state.SolarToolAswJsonSearch"
                            :dense = true
                            class="elevation-1"
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="customerSelected(item)"
                                >
                                    mdi-check
                                </v-icon>
                            </template>
                        </v-data-table>
<!--
                        <v-dialog v-model="$store.state.SolarToolCustomerNumberIsInvalid" width="1000">
                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title>
                                    SolarTool
                                </v-card-title>
                                <v-card-text>
                                    <v-flex xs12 sm12></v-flex>
                                    <v-card-text align="left">
                                        <h3>Le n° de client n'est pas connu. Veuillez vérifier SVP.</h3>
                                    </v-card-text>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" text @click="$store.state.SolarToolCustomerNumberIsInvalid = false">
                                        Ok
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
-->
                        <v-container
                            v-if="$store.state.SolarToolCustomerNumberIsValid"
                        >
                            <v-flex xs12 sm12 class="text-left">
                                <h3><u>Veuillez sélectionner les fichiers à importer</u> : </h3>
                                <v-flex class="ml-5">
                                    <h4>Fixations : <ul><li>Mounting Systems (PDF)</li><li>2Post Steel Mounting Systems (XLSX)</li><li>iFix (PDF)</li><li>ESDEC (1 ZIP par toiture <u>ou</u> CSV)</li></ul></h4>
                                    <h5>Toutes les structures peuvent être combinées.</h5>
                                </v-flex>
                            </v-flex>
                            <v-flex xs12 sm12 class="ml-5 text-left">
                                <h4>Onduleurs SMA (sdp3) ou Solaredge (PDF sans prix !) ou Huawei SmartDesign (1.0) (PDF)</h4>
                                <h5>(un seul choix possible) :</h5>
                            </v-flex>
                            <v-flex xs12 sm12 align="left" class="text-left">
                                <input type="file" multiple @change="filesCount" ref="SolarToolUploadFiles">
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs12 sm12 align="left" class="text-left">
                                <v-btn
                                    v-if="!$store.state.SolarToolIsUploading &&
                                    this.$store.state.SolarToolUploadedFilesNumber > 0"
                                    @click="this.SolarToolSubmitFiles" 
                                    dark>
                                    Télécharger
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm12 v-if="$store.state.SolarToolIsUploading">
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                            </v-flex>
                        </v-container>
                    </v-card-text>
                    <v-card-text>
                        <PageSolarToolResults/>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

</template>
<script>
    import PageSolarToolResults from './PageSolarToolResults.vue';
    import ToolBoxMixins from './mixins/ToolBoxMixins.js';
    import FormulaireRechercheClient from './FormulaireRechercheClient.vue';

	export default {
		name: "PageSolarTool",
		components: {
            PageSolarToolResults,
            FormulaireRechercheClient,
		},
		data: function () {
			return {
                societe: null,
                closeSolarTool: false,
                unknownCustomerNumber: false,
                NomProjetRules: [
                    (v) => !!v || "Champ obligatoire",
                    (v) =>
                    (v && v.length >= 2) ||
                    "Minimum 2 caractères",
                ],
                CustomerNumberRules: [
                    (v) => !!v || "Champ obligatoire",
                    (v) =>
                    (v && v.length >= 3) ||
                    "Numéro invalide",
                ],
                files: [],
                buttonPage1Text: "Télécharger",
            }
        },
        mixins: [
            ToolBoxMixins,
        ],
		methods: {
            mainPageActive: function () {
                this.solarToolResetData(true);
                this.$store.state.mainPageActive = true;
                this.$store.state.pageSolarToolActive = false;
				this.$store.state.pageSolarToolDbActive = false;
                this.closeSolarTool = false;
                this.$store.state.SolarToolFoundCustomers[0].Name_1 = '';
            },
            filesCount() {
                this.files = this.$refs.SolarToolUploadFiles.files;
                this.$store.state.SolarToolUploadedFilesNumber = this.files.length;
            },
            SolarToolOptions() {
                this.$store.state.pageSolarToolMainActive = false;
                this.$store.state.pageSolarToolOptionsActive = true;
                this.$store.state.SolarToolUploadedFilesNumber = 0;
            },
            customerNumberCheck() {
                this.$store.state.dmr++;
                if(this.$store.state.SolarToolCustomersList.includes(this.$store.state.SolarToolCustomerNumber) 
                    && this.$store.state.SolarToolCustomerNumber != "") {
                    this.$store.state.SolarToolCustomerNumberIsValid = true;
                    this.$store.state.SolarToolCustomerNumberIsInvalid = false;
                    this.$store.state.searchedCustomers.push(this.$store.state.SolarToolCustomerNumber);
                    this.searchCustomer();
                } else {
                    this.$store.state.SolarToolCustomerNumberIsValid = false;
                    this.$store.state.SolarToolCustomerNumberIsInvalid = true;                   
                }
            },
            customerSelected(item) {
                this.$store.state.SolarToolCustomerNumber = item.Cust_Supp_no;
                this.$store.state.SolarToolCustomerName = item.Name_1;
                this.customerNumberCheck();
                this.$store.state.SolarToolFoundCustomersDataTableVisible = false;
                this.$store.state.searchedCustomers.push(this.$store.state.SolarToolCustomerNumber);
            },
            openSearchCustomerTile() {
                this.SolarToolFoundCustomers = [];
                this.$store.state.SolarToolCustomerNumberIsValid = false;
                this.$store.state.SolarToolCustomerNumber = "";
                this.$store.state.customer.SOCIETE = "";
                this.$store.state.customer.TVA = "";
                this.$store.state.customer.RUE = "";
                this.$store.state.customer.CP = "";
                this.$store.state.customer.LOCALITE = "";
                this.$store.state.SolarToolSearchCustomerNumber = true;
                this.$store.state.SolarToolFoundCustomersDataTableVisible = true;
            },
        closeCustomerSearchForm() {
            this.$store.state.SolarToolSearchCustomerNumber = false;
            this.$store.state.SolarToolFoundCustomersDataTableVisible = false;
        }
        }
    }
</script>
